<script>
    import modals from '../state/modals';
    import user from '../state/user';
    import credits from '../state/credits';

    let showForm = true;
    let canEditForm = true;

    let count = 2;
    let message = {
        contents: null,
        isError: false
    };

    let currentUser;
    $: currentUser = $user;

    let lastState = null;
    $: onChange($modals.credits_opened);

    function onChange(state) {
        if (lastState === state) return;
        lastState = state;

        // Reset form
        canEditForm = true;
        message = {
            contents: null,
            isError: false
        };
    }

    function onUpdate() {
        let value = count;

        // Sanity check
        if (typeof value !== 'number') {
            if (!/^\d+$/.exec(value)) {
                value = 0;
            } else {
                value = parseInt(value);
            }

            count = value;
        }

        // Lower than the max
        if (value < 2) {
            count = 2;
            return;
        }
    }

    async function onSubmit() {
        canEditForm = false;

        let res = await credits.order(count);

        // Get message contents
        let txt = null;
        if (!res) {
            txt = 'Při požadavku došlo k chybě. Zkuste to později.';
        } else if (res.redirect) {
            txt = 'Kredity byly objednány, budete přesměrování na platební bránu.';
        } else {
            txt = 'Kredity byly objednány, pro zaplacení postupujte podle instrukcí v emailu.';
        }

        message = {
            contents: txt,
            isError: !res
        };

        // Redirect to payment
        if (res.redirect) {
            setTimeout(() => {
                location.href = res.redirect;
            }, 3000);
        }
    }

    function formatPrice(price) {
        return new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(price);
    }

    function closeModal(e) {
        modals.toggleCreditsModal(false);
    }
</script>

<style>
    footer {
        justify-content: flex-end;
    }

    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e4e4e4;
    }

    .group .text {
        background: #ececec;
        /* flex: 1; */
    }

    .input {
        width: 80px;
        margin: 10px 0;
    }

    .message {
        margin-top: 20px;
    }

    .message-body {
        padding: 0.5em 1em;
    }
</style>

{#if $modals.credits_opened}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeModal}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title">
                    Nákup kreditů
                </div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body has-text-centered">
                {#if showForm}
                    <article class="message is-info">
                        <div class="message-body">
                            1 kredit = 1 lekce
                        </div>
                    </article>

                    <div>
                        <strong>Vyberte počet kreditů k dobití</strong><br>
                        <input type="number" class="input" min="2" on:change={onUpdate} bind:value={count} readonly={!canEditForm}>
                    </div>

                    <div>
                        <div class="group">
                            <span class="caption">Celková cena</span>
                            <span class="text">{formatPrice(count * 130)}</span> <!-- TODO: replace with db value -->
                        </div>
                    </div>

                    {#if message.contents}
                        <article class="message" class:is-success={!message.isError} class:is-error={message.isError}>
                            <div class="message-body">
                                {message.contents}
                            </div>
                        </article>
                    {/if}
                {:else}
                    <article class="message is-info">
                        <div class="message-body">
                            Omlouváme se, ale aktuálně je nákup kreditů / lekcí možný pouze přes <b>Lindu&nbsp;Varnuškovou</b>:<br>
                            email: <b>chytrypohyb@email.cz</b><br>
                            <br>
                            Děkujeme za pochopení
                        </div>
                    </article>
                {/if}
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" disabled={!!message.contents || !showForm} on:click={onSubmit}>Zaplatit</button>
            </footer>
        </div>
    </div>
{/if}